import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent {
  search = '';
  user: any;
  timeZone: any;
  searchDate: any;
  notifications = [];
  category = '';
  categoryTabs = [
    { value: '', label: 'All' },
    { value: 'ticket', label: 'Tickets' },
    { value: 'other', label: 'Others' },
  ];
  totalPages = 0;
  totalResults = 0;
  currentPage: number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  validStatuses: string[] = [
    'pending',
    'scheduled',
    'offered',
    'onway',
    'arrived',
    'in_progress',
    'completed',
    'cancelled'
  ];
  constructor(
    private sharedDataService: SharedDataService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getNotifications(this.currentPage = 1);
  }

  getNotifications(page: any) {
    const queryParams: any = {
      sortBy: 'createdAt:desc',
      time: this.searchDate,
      limit: 50,
      page,
    };
    if (this.category) {
      queryParams.category = this.category;
    }
    this.sharedDataService
      .getNotifications(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.notifications = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      }, err => {
        // sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onNotificationClick(notification: any) {
    this.markAsRead(notification);
    // a support reply opens its ticket or chat
    if (notification.type === 'support' && notification.metadata?.url) {
      this.router.navigateByUrl(notification.metadata.url);
      return;
    }
    if (notification.type !== 'trip') {
      return;
    }
    const status = notification?.trip?.status;
    if (status && this.validStatuses.includes(status)) {
      this.router.navigate(['trips'], { fragment: status });
    }
  }

  onMarkSingleAsRead(event: MouseEvent, notification: any) {
    event.stopPropagation();
    this.markAsRead(notification);
  }

  onMarkAllAsRead() {
    this.sharedDataService.markAllAsRead(this.user?.company).subscribe({
      next: () => {
        if (Array.isArray(this.notifications)) {
          this.notifications.forEach((n: any) => n.isRead = true);
        }
        this.sharedDataService.refreshUnreadNotificationCount(true);
      },
      error: () => {}
    });
  }

  hasUnreadNotifications(): boolean {
    return Array.isArray(this.notifications) && this.notifications.some((n: any) => !n.isRead);
  }

  markAsRead(notification: any) {
    if (!notification || notification.isRead) {
      return;
    }
    notification.isRead = true;
    this.sharedDataService.decrementUnreadNotificationCount(1);

    this.sharedDataService
      .markNotificationAsRead(notification.id || notification._id)
      .subscribe({
        next: () => {},
        error: () => {}
      });
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;
        const startOfToday = this.timeZone ? moment.tz(this.timeZone).startOf('day').toISOString() : moment().startOf('day').toISOString();
        const endOfToday = this.timeZone ? moment.tz(this.timeZone).endOf('day').toISOString() : moment().endOf('day').toISOString();
        this.searchDate = [startOfToday, endOfToday];
      }
    })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getNotifications(page);
  }

  onSelectCategory(category: string) {
    this.category = category;
    this.getNotifications(this.currentPage = 1);
  }

  onSearchDateChange(event: any) {
    this.searchDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getNotifications(this.currentPage = 1);
  }

  getRelativeTime(date: any): string {
    return date ? moment(date).fromNow() : '';
  }

  ngOnDestroy(): void {
  }
}
